var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgJetCrossContentDefault = function SvgJetCrossContentDefault(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#242E30",
    d: "m16.42 17.663 1.242-1.243L10.234 9l7.428-7.429L16.42.338 9 7.766 1.57.338.337 1.57 7.767 9l-7.43 7.42 1.234 1.242L9 10.235z"
  })));
};
export { SvgJetCrossContentDefault as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE2LjQxOTkgMTcuNjYyNUwxNy42NjI0IDE2LjQyTDEwLjIzMzcgOS4wMDAwMkwxNy42NjI0IDEuNTcxMjdMMTYuNDE5OSAwLjMzNzUyNEw4Ljk5OTkgNy43NjYyN0wxLjU3MTE1IDAuMzM3NTI0TDAuMzM3NDAyIDEuNTcxMjdMNy43NjYxNSA5LjAwMDAyTDAuMzM3NDAyIDE2LjQyTDEuNTcxMTUgMTcuNjYyNUw4Ljk5OTkgMTAuMjMzOEwxNi40MTk5IDE3LjY2MjVaIiBmaWxsPSIjMjQyRTMwIi8+Cjwvc3ZnPgo=";